<template>
  <div  >
    <div v-if="this.screenWidth < 480">
      <Header :leftArrow="true" @leftClick="onClickLeft" @onRefreshClick="onRefresh"> </Header>
    </div>
    <div v-else>
      <Header
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        @onRefreshClick="onRefresh"
        :rightIcons="true"
      >
      </Header>
      <div></div>
    </div>
<!--    <Footer v-show="this.screenWidth < 700" />-->
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import { Toast } from "vant";
import "vant/es/toast/style";
export default {
  data() {
    return {
      screenWidth: null,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
  watch: {
    screenWidth: function (n, o) {},
  },
};
</script>

<style scoped>
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.info-title {
  display: flex;
  align-items: baseline;
}
.info-img img {
  margin-bottom: 10px;
}
.van-grid-item__content {
  border: 2px solid black;
  border-radius: 10px;
}
</style>
